import { httpClient } from '../utils/httpClient';
import { Curso } from '../types/usuario.types';
import { CursoPayload } from '../types/curso.types';

// ============================================================
// cursoService.ts
// httpClient extrae body.data y lanza Error(body.message)
// si success === false. Solo construimos la URL y el payload.
// ============================================================

export const cursoService = {

  async listar(): Promise<Curso[]> {
    return httpClient.get<Curso[]>('/cursos');
  },

  async obtener(id: number): Promise<Curso> {
    return httpClient.get<Curso>(`/cursos/${id}`);
  },

  async crear(payload: CursoPayload): Promise<Curso> {
    return httpClient.post<Curso>('/cursos', payload);
  },

  async modificar(id: number, payload: CursoPayload): Promise<Curso> {
    return httpClient.put<Curso>(`/cursos/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/cursos/${id}`);
  },
};
